import {
  SkeletonBlock,
} from "@/ui/components/primitives/Skeleton/SkeletonBlock";

export const ParagraphLines = () => (
  <div className="flex w-full flex-col gap-2">
    <SkeletonBlock className="h-4 w-full rounded-sys-md" />
    <SkeletonBlock className="h-4 w-3/4 rounded-sys-md" />
  </div>
);
